import React from 'react';
import { useTranslation } from 'react-i18next';

const StageIcon = ({ stage, checked = false }) => {
  const { i18n } = useTranslation();

  return (
    <div className="ratio ratio-1x1 w-100">
      <div
        className="border-skewed shadow"
        style={{ backgroundColor: '#FBD4A4' }}
      >
        <div className="d-flex">
          <img
            className="m-auto"
            src={
              stage.icon[0]?.path
                ? `/uploads/${stage.icon[0]?.path}`
                : '/assets/img/stage-default.png'
            }
            alt={i18n.pickLng(stage.refCode)}
            style={{ width: '60%' }}
          />
          {checked && (
            <div
              className="img-bg d-flex"
              style={{ backgroundColor: 'rgba(0, 0, 0, .5)' }}
            >
              <img
                className="m-auto"
                src="/assets/img/check.png"
                alt="Answered"
                style={{ width: '40%' }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StageIcon;
